import { render } from "./orcamento-editar.vue?vue&type=template&id=32bef261"
import script from "./orcamento-editar.vue?vue&type=script&lang=js"
export * from "./orcamento-editar.vue?vue&type=script&lang=js"

import "./orcamento-editar.vue?vue&type=style&index=0&id=32bef261&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__